
import './Preferential_Issue.css';

import useMeta from '../../../hooks/useMeta';


import Footer from "../../../CommonComponent/Footer/footer";
import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

const PrefIssueTwentyFour = () => {

    useMeta({
        title: 'Preferential Issue Warrants - 2026 | Marvel Blinds',
        description: "Statement of Deviation or Variation Complaince Certificate Reg.163 Outcome of Board Meeting_18_07_2024 Notice of EGM 14_08_2024 Attendence Slip Proxy Form Corrigendum to Notice of EGM Scrutinizer Report Proceedings of EGM 14_08_2024",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/preferential-issue`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Preferential issue',
            description: "Statement of Deviation or Variation Complaince Certificate Reg.163 Outcome of Board Meeting_18_07_2024 Notice of EGM 14_08_2024 Attendence Slip Proxy Form Corrigendum to Notice of EGM Scrutinizer Report Proceedings of EGM 14_08_2024",
            url: `${process.env.REACT_APP_WEBSITE_URL}/preferential-issue`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="PI-pg-container">
                <h2 className="PI-pg-title">Preferential Issue Warrants - 2026</h2>
                <table className="PI-pg-content-table">
                    
                </table>
            </div>
            <Footer />
        </>
    );
}

export default PrefIssueTwentyFour;